import React, { useState } from 'react';
import { Button } from '../UI/Button';
interface ApplicationFormProps {
  onFormSubmit: () => void;
}
export const ApplicationForm = ({
  onFormSubmit
}: ApplicationFormProps) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    location: '',
    role: '',
    experience: '',
    pastExperience: '',
    motivation: '',
    hours: '',
    linkedin: '',
    instagram: '',
    facebook: '',
    twitter: '',
    hasAttendedEvent: '',
    eventAttended: '',
    notes: '',
    consent: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    try {
      const response = await fetch('https://formspree.io/f/xanppkda', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        setFormData({
          fullName: '',
          email: '',
          phone: '',
          location: '',
          role: '',
          experience: '',
          pastExperience: '',
          motivation: '',
          hours: '',
          linkedin: '',
          instagram: '',
          facebook: '',
          twitter: '',
          hasAttendedEvent: '',
          eventAttended: '',
          notes: '',
          consent: false
        });
        // Call the parent component's callback to show the thank you page
        onFormSubmit();
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (err) {
      setError('There was an error submitting your application. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="bg-white p-6 rounded-lg border-2 border-gray-200" data-id="element-688" data-mp="333z12g9xtvql">
      <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-689" data-mp="2y55mekiwzyou">
        The Networking Salon — Team Application (Contract Roles)
      </h3>
      <p className="text-gray-600 mb-6" data-id="element-690" data-mp="3d2xzz74wid0e">
        We're excited that you're interested in joining The Networking Salon!
        Please fill out this short form carefully. It helps us learn about your
        experience, interests, and how you can contribute to our growing
        community.
      </p>
      <p className="text-gray-600 mb-6" data-id="element-691" data-mp="3h2ye0qo38m6x">
        These are contract-based roles (3–6 months, renewable) — part-time,
        remote or hybrid, and performance/commission-based.
      </p>
      {error && <div className="bg-red-50 border border-red-200 text-red-800 p-4 rounded-md mb-6" data-id="element-692" data-mp="3qttcquiite99">
          {error}
        </div>}
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-693" data-mp="8l289u0fhlm7">
        <div className="space-y-4" data-id="element-694" data-mp="4n4himr0ergp">
          <div data-id="element-695" data-mp="4k06b5f4mvgj">
            <label htmlFor="fullName" className="block text-gray-700 font-medium mb-1" data-id="element-696" data-mp="nadczou3m27n">
              Full Name
            </label>
            <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-697" data-mp="s85f1bogj4pk" />
          </div>
          <div data-id="element-698" data-mp="jacwlynfvgxy">
            <label htmlFor="email" className="block text-gray-700 font-medium mb-1" data-id="element-699" data-mp="4jvyopa0j95t">
              Email Address
            </label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-700" data-mp="9b499on2x0kk" />
          </div>
          <div data-id="element-701" data-mp="3vnkl61tpsu5f">
            <label htmlFor="phone" className="block text-gray-700 font-medium mb-1" data-id="element-702" data-mp="3hqfm4lsf4vjo">
              Phone Number (WhatsApp Preferred)
            </label>
            <input type="text" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-703" data-mp="3mopdelb0vc00" />
          </div>
          <div data-id="element-704" data-mp="k4pamt9o7xgd">
            <label htmlFor="location" className="block text-gray-700 font-medium mb-1" data-id="element-705" data-mp="k45qr70gmyzp">
              City & State of Residence
            </label>
            <input type="text" id="location" name="location" value={formData.location} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-706" data-mp="f3rsuhskp5fe" />
          </div>
          <div data-id="element-707" data-mp="15bcs08tm2kl">
            <label className="block text-gray-700 font-medium mb-1" data-id="element-708" data-mp="16w6xor83jhx">
              Have you ever attended any of The Networking Salon events?
            </label>
            <div className="space-y-2" data-id="element-709" data-mp="1vjug2516sa3o">
              {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-710" data-mp="1vi1db0tp2a0y">
                  <input type="radio" id={`hasAttendedEvent-${option}`} name="hasAttendedEvent" value={option} checked={formData.hasAttendedEvent === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-711" data-mp="1qmccyv9uop3l" />
                  <label htmlFor={`hasAttendedEvent-${option}`} className="text-gray-700" data-id="element-712" data-mp="27udaelkaqnya">
                    {option}
                  </label>
                </div>)}
            </div>
          </div>
          {formData.hasAttendedEvent === 'Yes' && <div data-id="element-713" data-mp="1f6pu3iq26jhg">
              <label className="block text-gray-700 font-medium mb-1" data-id="element-714" data-mp="1f790q3a9dlg6">
                Which event(s) did you attend? (Select all that apply)
              </label>
              <select name="eventAttended" value={formData.eventAttended} onChange={handleChange} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-715" data-mp="1p3ccm0uwwygb">
                <option value="" data-id="element-716" data-mp="30hzdzttixsl5">Select an event</option>
                <option value="Abuja" data-id="element-717" data-mp="34km8y3lhrtmk">Abuja</option>
                <option value="Port Harcourt" data-id="element-718" data-mp="34jb4e1k82hue">Port Harcourt</option>
                <option value="Benin" data-id="element-719" data-mp="15fcql68b4ino">Benin</option>
                <option value="Lagos" data-id="element-720" data-mp="15e1e8i0sq2ky">Lagos</option>
                <option value="Warri" data-id="element-721" data-mp="10hb0i1cgrj2p">Warri</option>
                <option value="Berlin" data-id="element-722" data-mp="10ivspkbb2pxe">Berlin</option>
                <option value="Houston Texas" data-id="element-723" data-mp="1egss0oh59afr">Houston Texas</option>
                <option value="Virtual Coffee Chat" data-id="element-724" data-mp="19hg2tx2svra0">Virtual Coffee Chat</option>
                <option value="Other" data-id="element-725" data-mp="19fd32lbuijs3">Other</option>
              </select>
            </div>}
          <div data-id="element-726" data-mp="ls538ix6s2xg">
            <label className="block text-gray-700 font-medium mb-1" data-id="element-727" data-mp="lpir05zcoz8w">
              Which role are you applying for?
            </label>
            <div className="space-y-2" data-id="element-728" data-mp="vhyax8u7jxwf">
              {['Community & Programs Lead', 'Content & Communications Lead', 'Tech & Systems Support'].map(option => <div key={option} className="flex items-center" data-id="element-729" data-mp="qpn89y831y06">
                  <input type="radio" id={`role-${option}`} name="role" value={option} checked={formData.role === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-730" data-mp="30c92l6dsbo5" />
                  <label htmlFor={`role-${option}`} className="text-gray-700" data-id="element-731" data-mp="29oupjs016cov">
                    {option}
                  </label>
                </div>)}
            </div>
          </div>
          <div data-id="element-732" data-mp="20q0wgblws4g2">
            <label className="block text-gray-700 font-medium mb-1" data-id="element-733" data-mp="20qj0vviq5oz2">
              Have you played this role before or done something similar?
            </label>
            <div className="space-y-2" data-id="element-734" data-mp="2td3t0y70y53o">
              {['Yes, I have experience in this exact role', "I've done something similar",, "I'm new to this but eager to learn"].map(option => <div key={option} className="flex items-center" data-id="element-735" data-mp="2xcw35fc2gjb5">
                  <input type="radio" id={`experience-${option}`} name="experience" value={option} checked={formData.experience === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-736" data-mp="2jexp6b1nqow6" />
                  <label htmlFor={`experience-${option}`} className="text-gray-700" data-id="element-737" data-mp="182n6wykjib5z">
                    {option}
                  </label>
                </div>)}
            </div>
          </div>
          <div data-id="element-738" data-mp="24kvjhl4seu0l">
            <label htmlFor="pastExperience" className="block text-gray-700 font-medium mb-1" data-id="element-739" data-mp="1znvap2gjzd5s">
              Briefly describe your past experience or related work
              <span className="block text-sm text-gray-500" data-id="element-740" data-mp="1upak7ur3s7uj">
                (Include any events, communities, or projects you've managed or
                contributed to.)
              </span>
            </label>
            <textarea id="pastExperience" name="pastExperience" value={formData.pastExperience} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-741" data-mp="2nfivd2n81rzm" />
          </div>
          <div data-id="element-742" data-mp="28ns7jrd3jibx">
            <label htmlFor="motivation" className="block text-gray-700 font-medium mb-1" data-id="element-743" data-mp="28o9zibsq7ae1">
              What excites you about joining The Networking Salon team?
            </label>
            <textarea id="motivation" name="motivation" value={formData.motivation} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-744" data-mp="31cflf1vin5fg" />
          </div>
          <div data-id="element-745" data-mp="3imt7tpa50ewp">
            <label className="block text-gray-700 font-medium mb-1" data-id="element-746" data-mp="3ima0f2i458wx">
              How many hours a week can you commit to this role?
            </label>
            <div className="space-y-2" data-id="element-747" data-mp="3njjq8j9ezmla">
              {['Less than 5 hours', '5–10 hours', '10–15 hours', 'More than 15 hours'].map(option => <div key={option} className="flex items-center" data-id="element-748" data-mp="gol1h8ngi5l">
                  <input type="radio" id={`hours-${option}`} name="hours" value={option} checked={formData.hours === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-749" data-mp="eu0i41ais21" />
                  <label htmlFor={`hours-${option}`} className="text-gray-700" data-id="element-750" data-mp="a8km91618oe1">
                    {option}
                  </label>
                </div>)}
            </div>
          </div>
          <div data-id="element-751" data-mp="k2tfjr2w0ld9">
            <label className="block text-gray-700 font-medium mb-3" data-id="element-752" data-mp="10w03hgdnp4k4">
              Social Media Links (for reference & engagement)
            </label>
            <div className="space-y-3" data-id="element-753" data-mp="14yeljy9i40ac">
              <div data-id="element-754" data-mp="14v8y0ngit6gq">
                <label htmlFor="linkedin" className="block text-gray-600 text-sm mb-1" data-id="element-755" data-mp="19w6bimql5cbw">
                  LinkedIn Profile
                </label>
                <input type="text" id="linkedin" name="linkedin" value={formData.linkedin} onChange={handleChange} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-756" data-mp="1eozjdjhcp0s7" />
              </div>
              <div data-id="element-757" data-mp="1smo2alruxxum">
                <label htmlFor="instagram" className="block text-gray-600 text-sm mb-1" data-id="element-758" data-mp="1so8y0epwrmu2">
                  Instagram Handle
                </label>
                <input type="text" id="instagram" name="instagram" value={formData.instagram} onChange={handleChange} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-759" data-mp="1xjwmst0hadz1" />
              </div>
              <div data-id="element-760" data-mp="3ruwdj5eekxqs">
                <label htmlFor="facebook" className="block text-gray-600 text-sm mb-1" data-id="element-761" data-mp="3rvfjdnqs3vog">
                  Facebook Profile
                </label>
                <input type="text" id="facebook" name="facebook" value={formData.facebook} onChange={handleChange} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-762" data-mp="3i3ryy6sn3ewh" />
              </div>
              <div data-id="element-763" data-mp="emt9fh6fiyam">
                <label htmlFor="twitter" className="block text-gray-600 text-sm mb-1" data-id="element-764" data-mp="el8f9so11hda">
                  X (Twitter) Handle
                </label>
                <input type="text" id="twitter" name="twitter" value={formData.twitter} onChange={handleChange} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-765" data-mp="4odjvin1vx38" />
              </div>
            </div>
          </div>
          <div data-id="element-766" data-mp="2ldiwwes8jr3g">
            <label htmlFor="notes" className="block text-gray-700 font-medium mb-1" data-id="element-767" data-mp="2lczekwyob0ow">
              Any other notes or message for us?
            </label>
            <textarea id="notes" name="notes" value={formData.notes} onChange={handleChange} rows={3} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-768" data-mp="2ruaqc6jk19wi" />
          </div>
          <div className="pt-2" data-id="element-769" data-mp="2hvbop7x7iej0">
            <div className="flex items-start" data-id="element-770" data-mp="2hua4ody7qhp5">
              <input type="checkbox" id="consent" name="consent" checked={formData.consent} onChange={handleChange} required className="mr-2 mt-1 h-4 w-4 border-2 border-gray-300" data-id="element-771" data-mp="2446oa3m0li7m" />
              <label htmlFor="consent" className="text-gray-700" data-id="element-772" data-mp="1u6k7tcp2hilj">
                I confirm that the information I've provided is accurate and
                that I understand this is a part-time, contract-based
                opportunity with performance-linked compensation.
              </label>
            </div>
          </div>
        </div>
        <div className="pt-2" data-id="element-773" data-mp="1p65wnls65sja">
          <Button type="submit" disabled={isSubmitting} className="w-full py-3" data-id="element-774" data-mp="1p9jxgpl6ptom">
            {isSubmitting ? 'Submitting...' : 'Submit Application'}
          </Button>
        </div>
      </form>
    </div>;
};